import { EntityConfig } from 'angular-odata';

//#region ODataApi Imports
import { GroupTree } from './grouptree.entity';
//#endregion

export const GroupTreeConfig = {
  name: "GroupTree",
  annotations: [],
  fields: {
    parentId: {type: 'Edm.String'},
    childId: {type: 'Edm.String'},
    level: {type: 'Edm.Int16', nullable: false},
    name: {type: 'Edm.String'},
    description: {type: 'Edm.String'},
    value: {type: 'Edm.String'},
    sortValue: {type: 'Edm.Int32', nullable: false},
    isActive: {type: 'Edm.Boolean', nullable: false},
    hasChild: {type: 'Edm.Boolean', nullable: false},
    maingroupId: {type: 'Edm.Int32'},
    icon: {type: 'Edm.String'},
    image: {type: 'Edm.String'},
    refGroupTreeId: {type: 'Edm.Int32', nullable: false},
    refType: {type: 'services.RefType', nullable: false},
    isNodeEditAllow: {type: 'Edm.Boolean', nullable: false},
    isNodePrivate: {type: 'Edm.Boolean', nullable: false},
    privatePersonId: {type: 'Edm.Int32'},
    useArtikel: {type: 'Edm.Boolean', nullable: false},
    useAttribute: {type: 'Edm.Boolean', nullable: false},
    useAssets: {type: 'Edm.Boolean', nullable: false},
    useKunden: {type: 'Edm.Boolean', nullable: false},
    useWettbewerber: {type: 'Edm.Boolean', nullable: false},
    useWettbewerberPreis: {type: 'Edm.Boolean', nullable: false},
    useArtikelPreis: {type: 'Edm.Boolean', nullable: false},
    useArtikelPreisVk: {type: 'Edm.Boolean', nullable: false},
    useRegistration: {type: 'Edm.Boolean', nullable: false},
    usedMaingroups: {type: 'Edm.String'},
    useAktie: {type: 'Edm.Boolean', nullable: false},
    isSystemRelevant: {type: 'Edm.Boolean', nullable: false},
    statusId: {type: 'Edm.Int32'},
    statusTypeId: {type: 'Edm.Int32'},
    statusAt: {type: 'Edm.DateTimeOffset'},
    statusBy: {type: 'Edm.String'},
    createdBy: {type: 'Edm.String'},
    id: {type: 'Edm.Int32', key: true, ref: 'id', nullable: false},
    maingroup: {type: 'entities.schema.Maingroup', navigation: true, field: 'maingroupId', ref: 'id'},
    groupTreeAssigments: {type: 'entities.schema.GroupTreeAssigment', collection: true, navigation: true},
    attributes: {type: 'entities.schema.GroupTreeAttribute', collection: true, navigation: true},
    statusGroupTree: {type: 'entities.settings.StatusGroupTree', collection: true, navigation: true},
    status: {type: 'entities.settings.Status', navigation: true, field: 'statusId', ref: 'id'},
    statusType: {type: 'entities.settings.StatusType', navigation: true, field: 'statusTypeId', ref: 'id'}
  }
} as EntityConfig<GroupTree>;